import React from 'react'
import styled from 'styled-components'
import Artwork from './Redirect.png'

function InternalErrorMessage({errorTitle = '', errorMessage = '', providedLinks = []}) {

  const renderLinks = () => {
    return providedLinks.map(({ title, link }) => (
      <ContentButton style={{textDecoration: 'none', color: '#fff !important'}} key={title} href={link}>
        <span>{title}</span>
      </ContentButton>
    ))
  }

  return (
    <Wrapper>
      <LeftSection>
        <svg xmlns="http://www.w3.org/2000/svg" width="256" height="31" viewBox="0 0 256 31" fill="none">
          <g clip-path="url(#clip0_1_7593)">
            <path d="M69.615 23.9672C71.6726 23.9672 73.0875 21.4974 73.6492 19.2831L77.7134 21.6296C76.611 25.1569 73.7363 27.215 69.3716 27.215C63.9677 27.215 60.399 23.3332 60.399 17.5134C60.399 11.6937 64.1419 7.56848 69.7201 7.56848C73.7393 7.56848 76.614 9.62658 77.7164 13.1539L73.6522 15.5004C73.0905 13.2861 71.6756 10.8164 69.618 10.8164C66.7733 10.8164 65.3224 13.3552 65.3224 17.4083C65.3224 21.4614 66.7733 23.9672 69.618 23.9672H69.615Z" fill="white" />
            <path d="M80.2457 26.8665V1.2229H84.8897V11.6095C86.1153 9.23896 88.2511 7.56545 90.7803 7.56545C94.8326 7.56545 97.2928 10.3386 97.2928 14.7733V26.8665H92.6518V15.3261C92.6518 13.0036 91.3691 11.2099 89.2904 11.2099C86.623 11.2099 84.8897 13.6977 84.8897 16.9906V26.8665H80.2457Z" fill="white" />
            <path d="M99.4045 17.4082C99.4045 11.5164 103.286 7.56543 109.071 7.56543C114.857 7.56543 118.701 11.5164 118.701 17.4082C118.701 23.3001 114.857 27.215 109.071 27.215C103.286 27.215 99.4045 23.2641 99.4045 17.4082ZM109.071 23.9671C111.982 23.9671 113.817 21.4613 113.817 17.4112C113.817 13.3612 111.982 10.8163 109.071 10.8163C106.16 10.8163 104.325 13.3612 104.325 17.4112C104.325 21.4613 106.127 23.9671 109.071 23.9671Z" fill="white" />
            <path d="M120.017 17.4082C120.017 11.5164 123.898 7.56543 129.684 7.56543C135.469 7.56543 139.314 11.5164 139.314 17.4082C139.314 23.3001 135.469 27.215 129.684 27.215C123.898 27.215 120.017 23.2641 120.017 17.4082ZM129.684 23.9671C132.594 23.9671 134.43 21.4613 134.43 17.4112C134.43 13.3612 132.594 10.8163 129.684 10.8163C126.773 10.8163 124.937 13.3612 124.937 17.4112C124.937 21.4613 126.74 23.9671 129.684 23.9671Z" fill="white" />
            <path d="M141.6 26.8665V1.2229H146.244V26.8665H141.6Z" fill="white" />
            <path d="M230.96 26.8665V23.2701C229.794 25.821 227.529 27.2121 224.895 27.2121C220.843 27.2121 218.382 24.4389 218.382 20.0042V7.91101H223.023V19.4514C223.023 21.8069 224.27 23.9642 226.316 23.9642C229.47 23.9642 230.647 21.0798 230.647 17.8229V7.91101H235.291V26.8665H230.96Z" fill="white" />
            <path d="M237.52 22.3658L241.065 20.3197C241.921 22.7774 243.993 23.9672 245.76 23.9672C247.664 23.9672 249.052 22.8134 249.052 21.4644C249.052 20.4609 248.394 19.905 246.904 19.5926L243.059 18.8655C239.767 18.2766 237.862 16.6481 237.862 13.5986C237.862 10.1343 241.086 7.56848 245.483 7.56848C248.779 7.56848 250.971 8.72222 252.861 11.8559L249.352 13.881C248.421 11.871 247.006 10.8164 245.102 10.8164C243.405 10.8164 242.158 11.8649 242.158 13.0788C242.158 14.0132 242.816 14.6381 244.237 14.9145L248.049 15.6416C251.548 16.2996 253.453 17.9281 253.453 20.9777C253.453 24.5831 250.302 27.215 245.694 27.215C241.987 27.215 239.058 25.7008 237.52 22.3658Z" fill="white" />
            <path d="M206.165 21.7888V11.3751H203.123V7.91391H206.165V4.04409L210.807 2.71008V7.91391H215.547V11.3751H210.807V22.2004C210.807 22.8674 211.347 23.4082 212.014 23.4082H215.547V26.8694H211.242C208.436 26.8694 206.162 24.595 206.162 21.7888H206.165Z" fill="white" />
            <path d="M171.612 21.7888V11.3751H168.569V7.91391H171.612V4.04409L176.253 2.71008V7.91391H180.993V11.3751H176.253V22.2004C176.253 22.8674 176.793 23.4082 177.46 23.4082H180.993V26.8694H176.688C173.883 26.8694 171.609 24.595 171.609 21.7888H171.612Z" fill="white" />
            <path d="M196.658 11.2791C195.538 9.00164 193.414 7.56848 190.804 7.56848C185.712 7.56848 182.351 11.5194 182.351 17.4113C182.351 23.3032 185.643 27.2181 190.56 27.2181C193.327 27.2181 195.379 25.9471 196.658 23.5075V26.8725H201.023V7.911H196.658V11.2761V11.2791ZM191.912 23.9672C189.037 23.9672 187.235 21.4614 187.235 17.4113C187.235 13.3612 189.037 10.8164 191.912 10.8164C194.787 10.8164 196.625 13.3612 196.625 17.4113C196.625 21.4614 194.823 23.9672 191.912 23.9672Z" fill="white" />
            <path d="M161.573 12.8684L156.965 11.7928C154.919 11.3091 153.952 10.5459 153.952 9.05567C153.952 7.32207 155.487 5.66057 157.971 5.66057C160.278 5.66057 162.078 7.02161 162.6 10.0231L166.788 7.60449C165.127 3.50933 162.159 2.26245 158.106 2.26245C153.048 2.26245 149.098 5.34809 149.098 9.5394C149.098 13.2139 151.21 15.2931 155.091 16.1914L159.698 17.267C161.708 17.7177 163.024 18.3757 163.024 20.1784C163.024 21.9811 161.42 23.8139 158.752 23.8139C155.884 23.8139 153.667 21.7828 153.141 18.7603L148.875 21.224C150.077 25.2651 153.823 27.212 158.404 27.212C163.976 27.212 167.911 24.0242 167.911 19.6917C167.911 15.7077 165.382 13.7668 161.57 12.8654L161.573 12.8684Z" fill="white" />
            <path d="M52.4237 12.8684L47.8158 11.7928C45.7701 11.3091 44.8029 10.5459 44.8029 9.05567C44.8029 7.32207 46.3379 5.66057 48.8221 5.66057C51.117 5.66057 52.9284 7.02161 53.4511 10.0231L57.6385 7.60449C55.9773 3.50933 53.0095 2.26245 48.9573 2.26245C43.8987 2.26245 39.9486 5.34809 39.9486 9.5394C39.9486 13.2139 42.0603 15.2931 45.9414 16.1914L50.5493 17.267C52.5589 17.7177 53.8746 18.3757 53.8746 20.1784C53.8746 21.9811 52.2705 23.8139 49.6031 23.8139C46.7344 23.8139 44.5175 21.7828 43.9918 18.7603L39.7263 21.224C40.9279 25.2651 44.6737 27.212 49.2546 27.212C54.8268 27.212 58.7619 24.0242 58.7619 19.6917C58.7619 15.7077 56.2327 13.7668 52.4207 12.8654L52.4237 12.8684Z" fill="white" />
            <path d="M26.6085 4.97549V21.4763C26.6085 22.2124 26.0978 22.8824 25.2717 23.3692L13.3043 30.2796L11.9675 29.5074V13.0066L23.8989 6.1142C24.4066 5.82276 24.719 5.41715 24.719 4.97248C24.719 4.52781 24.4066 4.1222 23.8989 3.82776C23.3913 3.53632 22.6914 3.35305 21.9194 3.35305C21.1474 3.35305 20.4475 3.53332 19.9398 3.82776L8.0084 10.7171V27.218C7.1583 27.7077 5.98679 28.0112 4.69211 28.0112C3.39744 28.0112 2.22292 27.7077 1.37583 27.218C1.36381 27.212 1.3518 27.2029 1.33978 27.1969C0.513712 26.7072 0.00305176 26.0402 0.00305176 25.3041V8.80625C0.00305176 8.07015 0.513712 7.40014 1.33978 6.9134C1.3518 6.9074 1.36381 6.89838 1.37583 6.89237L13.3043 0L14.641 0.772162L2.70955 7.66153C2.2049 7.95297 1.88949 8.35858 1.88949 8.80325C1.88949 9.24792 2.20189 9.65353 2.70955 9.94797C3.21721 10.2394 3.91711 10.4227 4.68911 10.4227C5.46111 10.4227 6.16101 10.2424 6.66867 9.94797L18.6001 3.0586C19.4502 2.56887 20.6217 2.26541 21.9164 2.26541C23.2111 2.26541 24.3856 2.56887 25.2327 3.0586C25.2447 3.06461 25.2567 3.07363 25.2687 3.07963C26.0948 3.56937 26.6054 4.23638 26.6054 4.97248L26.6085 4.97549Z" fill="white" />
          </g>
          <defs>
            <clipPath id="clip0_1_7593">
              <path d="M0 8.00001C0 3.58173 3.58172 0 8 0H248C252.418 0 256 3.58172 256 8V30.2796H0V8.00001Z" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <LeftSectionContent>
        </LeftSectionContent>
        <ArtworkWrapper>
          <img className='connect-artwork' src={Artwork} />
        </ArtworkWrapper>
      </LeftSection>
      <MainContent>
        <TopSection>
          <a style={{ fontWeight: '400', color: 'black' }} href="https://www.schoolstatus.com/schoolstatus-help-center">
            Get Help
          </a>
          <a style={{ fontWeight: '400', color: 'black' }} href="https://ss.ly/OybYsB">
            News
          </a>
        </TopSection>
        <ContentSection>
          <div>
            <h2 style={{ marginBottom: '32px' }}>
              {errorTitle}
            </h2>
            <div className='my-5'>
              <p style={{ width: '90%' }}>
                {errorMessage}
              </p>
            </div>
            <div className='mt-5 d-flex justify-content-around'>
              {renderLinks()}
            </div>
          </div>
        </ContentSection>
      </MainContent>
    </Wrapper >
  )
}

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  font-family: text--default;
  background-color: white;
`
const LeftSection = styled.section`
  min-height: 100vh;
  opacity: 1 !important;
  background-color: #1A1A1A;
  display: flex;
  height: 100%;
  width: 480px;
  padding: 32px 48px 96px 48px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;

  @media (max-width: 950px) {
    width: 380px;
  }

  @media (max-width: 775px) {
    width: 300px;

    svg{
      width: 200px;
    }
  }
`

const LeftSectionContent = styled.div`
  display: flex;
  width: 380px;
  padding-bottom: 65px;
  flex-direction: column;
  align-items: center;
  gap: 72px;
  color: white;
  margin-top: 130px;

  @media (max-width: 950px) {
    width: fit-content;
  }
`

const ArtworkWrapper = styled.span`
  position: absolute;
  bottom: 10px;
  left: 75px;
  .connect-artwork{
    width: 457.46px;
  }

  @media (max-width: 950px) {
    left: 25px;
    .connect-artwork{
      width: 397.46px !important;
    }
  }

  @media (max-width: 775px) {
    left: 35px;
    .connect-artwork{
      width: 297.46px !important;
    }
  }
`

const MainContent = styled.div`
  display: flex;
  height: 100%;
  padding: 24px 85px 0px 85px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  width: calc(100% - 488px);
  background-color: white;

  @media (max-width: 950px) {
    width: calc(100% - 380px);
  }

  @media (max-width: 775px) {
    width: calc(100% - 300px);
  }
`
const TopSection = styled.div`
  display: flex;
  padding: 8px 0px 60px 0px;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  height: 20%;
  text-align: right;

  @media (max-width: 975px) {
    padding: 8px 0px 50px 0px;
  }
`

const ContentSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
`

const ContentButton = styled.a`
  background-color: #1A1A1A;
  color: #fff;
  padding: 10px;
  border-radius: 5px;

  :hover{
    color: #fff;
  }
`

export default InternalErrorMessage
